import { Modal, Form, Input, Button, Row, Col, Divider, message } from "antd";
import { useEffect } from "react";

const EditOrderModel = ({ isModalVisible, setIsModalVisible, editingOrder, form, onUpdate }) => {

    useEffect(() => {
        if (editingOrder) {
            form.setFieldsValue({
                ...editingOrder,
                Items: editingOrder.Items || []
            });
        }
    }, [editingOrder, form]);

    const handleFinish = (values) => {
        console.log("Updated Order:", values);
        setIsModalVisible(false);
        onUpdate({
            ...editingOrder, // Preserve original data not in form
            ...values,
            Items: values.Items || [] // Explicitly include Items
        });
        message.success("Order updated successfully!");
    };

    
    return (
        <Modal
            title="Edit Order"
            open={isModalVisible}
            width={1000} // Wider layout for landscape design
            onCancel={() => setIsModalVisible(false)}
            onOk={() => form.submit()}
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                {/* Customer Information */}
                <Divider orientation="left">Customer Info</Divider>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Buyer Name" name="BuyerName">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Buyer Email" name="BuyerEmail">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Buyer Phone Number" name="BuyerPhoneNumber">
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Shipping Details */}
                <Divider orientation="left">Shipping Info</Divider>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Ship City" name="ShipCity">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Ship State" name="ShipState">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Ship Country" name="ShipCountry">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Ship Postal Code" name="ShipPostalCode">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Recipient Name" name="RecipientName">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Ship Phone Number" name="ShipPhoneNumber">
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Address Details */}
                <Divider orientation="left">Address Details</Divider>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="Ship Address 1" name="ShipAddress1">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Ship Address 2" name="ShipAddress2">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Ship Address 3" name="ShipAddress3">
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Order Items */}
                <Divider orientation="left">Order Items</Divider>
                {editingOrder?.Items?.map((item, index) => (
                    <Row gutter={16} key={index} style={{ marginBottom: 10 }}>
                        <Col span={6}>
                            <Form.Item label="SKU" name={["Items", index, "SKU"]} initialValue={item.SKU}>
                                <Input disabled />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Product Name" name={["Items", index, "ProductName"]} initialValue={item.ProductName}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Quantity" name={["Items", index, "QuantityPurchased"]} initialValue={item.QuantityPurchased}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Item Price" name={["Items", index, "ItemPrice"]} initialValue={item.ItemPrice}>
                                <Input disabled />
                            </Form.Item>
                        </Col>
                    </Row>
                ))}

                {/* Payment Details */}
                <Divider orientation="left">Payment Info</Divider>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="Currency" name="Currency">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Item Tax" name="ItemTax">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Shipping Price" name="ShippingPrice">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Service & Address Type */}
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Ship Service Level" name="ShipServiceLevel">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Address Type" name="AddressType">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default EditOrderModel;